<app-loading-bar></app-loading-bar>

<div class="flex column" *ngIf="event" style="font-size:medium">

    <h1 style="padding: 0px 15px;font-size:xx-large">{{event?.title }}
        <span class="tag" *ngIf="isOwnerOfBooking()">{{'Your Booking' | translate}}</span>
    </h1>
    <div style="max-height: 30vh;min-height:30vh;
    overflow: hidden;display:flex">
        <img style="width:100%;object-fit: contain;" [ngClass]="{'placeholderImage': !event?.mapUrlLocation}" [src]="event?.mapUrlLocation ? getMapUrlWithCacheBust(event.mapUrlLocation) : '../../../assets/img/crewcus-logo' ">
    </div>
    <div style="padding: 10px 15px;">
        <div>{{'Location' | translate}}:
            <div style="font-weight:bold">{{event?.location}} {{'- ' + event?.room}}</div>
        </div>
    </div>
    <div class="flex" style="place-content: space-between;">
        <div style="padding: 10px 15px;">{{'Start of Reservation' | translate}}:
            <div>{{'End of Reservation' | translate}}:</div>
        </div>

        <div style="padding: 10px 15px;">
            <div>{{event?.startTime | date: 'medium':undefined:'de-DE'}}</div>
            <div>{{event?.endTime | date: 'medium':undefined:'de-DE'}}</div>
        </div>





    </div>

    <div class="flex" style="place-content: space-between;">
        <div style="padding: 10px 15px;">{{'Booked by' | translate}}:

        </div>

        <div style="padding: 10px 15px;">
            <div>{{isOwnerOfBooking() ? this.user.username : event?.username}}</div>

        </div>





    </div>

    <button *ngIf="isOwnerOfBooking()" (click)="showDeleteBookingModal()" class="secondary rebrand">{{'Delete Booking' | translate}}</button>
    <button *ngIf="showSuperAdmin" (click)="showDeleteBookingModal()" class="secondary rebrand">[Superadmin] {{'Delete Booking' | translate}}</button>

    <!-- Recovery code deletion link for users who lost their session -->
    <div style="text-align: center; margin-top: 20px; margin-bottom: 20px;">
        <a (click)="showDeleteBookingWithRecoveryCodeModal = true" style="color: var(--primary); text-decoration: underline; cursor: pointer; font-size: 14px;">
            {{'Can\'t delete your booking? Click here to delete using your recovery code' | translate}}
        </a>
    </div>

    <button (click)="routeToCalendar()" class="primary rebrand">{{'Back' | translate}}</button>

</div>

<div class="modal" [ngClass]="{'active': showDeleteConfirm}">

    <div class="content  ">
        <i class="fas fa-times" (click)="showDeleteConfirm = false"></i>
        <div class="flex column overflow-hidden">


            <div class="slider" id="onboarding-slider">

                <div class="flex column step" *ngIf="!showDeleteSuccess">
                    <img style="margin: auto;
                    width: 100%;object-fit: contain;" src="../../../assets/img/booking.svg">
                    <span class="subtitle">{{'Confirm Delete' | translate}}</span>

                    <div class="description">
                        {{'Do you really want to delete this reservation? This process cannot be undone.' | translate}}
                    </div>

                    <div class="button-holder">
                        <button (click)="deleteBooking()" class="primary rebrand red">{{'Delete' | translate}}</button>
                    </div>

                </div>

                <div class="flex column step" *ngIf="showDeleteSuccess">
                    <img style="margin: auto;
                    width: 100%;object-fit: contain;" src="../../../assets/img/booking.svg">
                    <h1 style="text-align: center;">{{'Delete Successful' | translate}}!</h1>

                    <div class="button-holder">
                        <button (click)="confirmModal()" class="primary rebrand">{{'OK' | translate}}</button>
                    </div>

                </div>


            </div>


        </div>
    </div>
    <div class="backdrop"></div>
</div>

<!-- Recovery Code Deletion Modal -->
<div class="modal" [ngClass]="{'active': showDeleteBookingWithRecoveryCodeModal}">
    <div class="content" style="position: relative; display: flex; justify-content: center; align-items: flex-start;">
        <i class="fas fa-times" (click)="showDeleteBookingWithRecoveryCodeModal = false" style="position: absolute; top: 10px; right: 10px; cursor: pointer;"></i>
        <div class="flex column overflow-hidden">
            <div class="slider" id="onboarding-slider">
                <div class="flex column step" style="width: 90%; text-align: center; align-items: center; padding: 20px;">
                    <img style="margin: auto; width: 100%; object-fit: contain;" src="../../../assets/img/booking.svg">
                    <span class="subtitle">{{'Delete Booking with Recovery Code' | translate}}</span>
                    <div class="description" style="width: 100%;">
                        {{'Enter your recovery code to delete this booking' | translate}}
                    </div>

                    <input 
                        type="text" 
                        [(ngModel)]="recoveryCodeForDelete"
                        placeholder="{{'Enter recovery code' | translate}}"
                        maxlength="9"
                        style="
                            width: 100%;
                            padding: 10px;
                            margin: 15px 0 10px 0;
                            border: 1px solid #ccc;
                            border-radius: 4px;
                            font-size: 14px;
                            box-sizing: border-box;
                        "
                    />

                    <button (click)="deleteBookingWithRecoveryCode()" class="primary rebrand red" style="width: 100%; margin-bottom: 15px;">
                        {{'Delete' | translate}}
                    </button>

                    <div style="text-align: center;">
                        <a (click)="showDeleteBookingWithRecoveryCodeModal = false" style="color: var(--primary); text-decoration: underline; cursor: pointer; font-size: 14px;">
                            {{'Cancel' | translate}}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="backdrop" (click)="showDeleteBookingWithRecoveryCodeModal = false"></div>
</div>
